import React, { useEffect, useState } from 'react';

const isServer = typeof window === 'undefined';

const FeedbackButton = ({ handleOpenFeedbackModal }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isServer) {
      setShow(true);
    }
  }, []);
  if (!show) return;

  const shouldHideChat = typeof window !== 'undefined' && window.hideChat;

  return (
    <button
      id='feedback_button'
      onClick={(e) => handleOpenFeedbackModal(e)}
      style={shouldHideChat ? { right: '-25px' } : {}}
    >
      <p id='feedback_button_text'>{shouldHideChat ? 'Feedback' : 'Chat | Feedback'}</p>
    </button>
  );
};

export default FeedbackButton;
